var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      { staticClass: "boss-table-data", attrs: { "data-test": "option-type" } },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.option.isPhotoClip ? "フォトクリップ" : "インタビュー") +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data",
        attrs: { "data-test": "option-title" },
      },
      [_vm._v("\n    " + _vm._s(_vm.option.title) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data",
        attrs: { "data-test": "publish-date" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("formatDate")(_vm.option.startDate)) +
            " ~ " +
            _vm._s(_vm._f("formatDate")(_vm.option.endDate)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c("td", { staticClass: "boss-table-data" }, [
      _vm.option.isPhotoClip
        ? _c(
            "button",
            {
              staticClass: "boss-button",
              attrs: { "data-test": "photo-clip-button" },
              on: {
                click: function ($event) {
                  return _vm.windowOpenPreview(
                    "photoClipPublishedPreview",
                    _vm.option.id
                  )
                },
              },
            },
            [_vm._v("\n      フォトクリップ\n    ")]
          )
        : _c(
            "button",
            {
              staticClass: "boss-button",
              attrs: { "data-test": "interview-button" },
              on: {
                click: function ($event) {
                  return _vm.windowOpenPreview(
                    "interviewPublishedPreview",
                    _vm.option.id
                  )
                },
              },
            },
            [_vm._v("\n      インタビュー\n    ")]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }